var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{},[_c('p',{staticClass:"title has-text-centered"},[_vm._v("\n      Connecting to your "+_vm._s(_vm.service)+" account...\n    ")])]),_vm._v(" "),_c('b-loading',{attrs:{"active":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }